import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { CardSection, CardHeader } from '../../../../../../components/Card';
import NotificationUser from './NotificationUser';
import Button from '../../../../../../components/inputs/Button';
import { Element } from '../../styled';
import FormInput from '../../../../../../components/inputs/FromInput';
import FormInputTel from '../../../../../../components/inputs/FromInputTel';
import Buttons from '../../../../../../modules/Buttons';
import { useForm, useFetch } from '../../../../../../hooks';
import Divider from '../../../../../../components/Divider';
import { pathOr } from 'ramda';

const Notifications = ({ data: mainData, data: { buttons, data, title }, refetchAccount }) => {
    const { doFetch } = useFetch({
        url: `/rpc/setusersphone`,
        method: 'POST'
    })

    const { doFetch: doFetchSendtestsms } = useFetch({
        url: `/rpc/sendtestsms`,
        method: 'POST'
    })

    const initValues = Object.fromEntries(data.map((user, index) => (
        [
            [`user${index + 1}`, user.name === null ? '' : user.name],
            [`number${index + 1}`, user.phone === null ? '' : user.phone]
        ]
    )).flat())


    const [isEditMode, setEditMode] = useState(false);

    const validate = values => {

        const errors = {}

        // if (values.number1.length !== 0 && values.number1.length !== 9) {
        //     errors.number1 = "Wprowadź 9-cyfrowy numer telefonu"
        // }
        // if (values.number2.length !== 0 && values.number2.length !== 9) {
        //     errors.number2 = "Wprowadź 9-cyfrowy numer telefonu"
        // }

        return errors
    }

    const save = values => {
        doFetch({
            data: values
        }).then(res => {
            if (res === 1) {
                setEditMode(false);
                refetchAccount();
            } else {
                throw Error(res)
            }
        }).catch(err => {
            console.log(err)
        });

    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: save,
        validate: validate,
        initValues: initValues
    })

    const handleClickTest = (user, number) => async () => {
        const res = await doFetchSendtestsms({
            data: {
                phone_no: number,
                description: user
            }
        });
        if(res === 1) {
            const infoMessage = pathOr(null, ['test-modal', 'info'], mainData);
            infoMessage && toast.success(infoMessage);
        } else {
            const errorMessage = pathOr(null, ['test-modal', 'error'], mainData);
            errorMessage && toast.error(errorMessage);
        }
    }

    return (
        <CardSection>
            <CardHeader>{title}</CardHeader>
            <Divider />
            {isEditMode ? (
                <form onSubmit={handleSubmit}>
                    {data && data.map((user, index) => (
                        <Element key={user.name || index}>
                            <Element>
                                <FormInput
                                    type='text'
                                    label={user['name-label']}
                                    placeholder={user['name-placeholder']}
                                    name={`user${index + 1}`}
                                    onChange={handleChange}
                                    value={values[`user${index + 1}`]}
                                    error={errors[`user${index + 1}`]}
                                />
                            </Element>
                            <Element>
                                <FormInputTel
                                    type='text'
                                    label={user['phone-label']}
                                    placeholder={user['phone-placeholder']}
                                    onlyCountries={mainData['only-countries']}
                                    name={`number${index + 1}`}
                                    onChange={handleChange}
                                    value={values[`number${index + 1}`]}
                                    error={errors[`number${index + 1}`]}
                                    style={{ flex: 1 }}
                                />
                            </Element>
                            <Button
                                type="button"
                                width="50%"
                                green
                                style={{ display: 'block', margin: '0 auto 30px auto'}}
                                onClick={handleClickTest(values[`user${index + 1}`], values[`number${index + 1}`])}
                            >
                                {mainData['test-modal'] && mainData['test-modal']['button']}
                            </Button>
                        </Element>
                    ))}
                    <Buttons stretch>
                        <Button
                            type="button"
                            width="48%"
                            onClick={() => setEditMode(false)}
                        >
                            {buttons.cancel}
                        </Button>
                        <Button type="submit" green width="48%">
                            {buttons.save}
                        </Button>
                    </Buttons>
                </form>
            ) : (
                    <>
                        {data && data.map((user, index) => (
                            <NotificationUser user={user} key={user.name ? user.name : index} />
                        ))}
                        <Button green fullWidth onClick={() => setEditMode(true)}>{buttons.edit}</Button>
                    </>
                )}

        </CardSection>
    )
}


export default Notifications
